module.exports = __webpack_public_path__ + "static/img/ohhi.4abf045.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/memes/ohhi.jpg
// module id = nb1m
// module chunks = 1